import Vue from 'vue'
import VueScrollTo from 'vue-scroll-to'
import VueResource from 'vue-resource'
import VModal from 'vue-js-modal'
import VueAgile from 'vue-agile'

// import Social from './Social.vue'
import Booking from './Booking.vue'
import Header from './Header.vue'
import Slider from './Slider.vue'

import './style.scss';


Vue.use(VModal);
Vue.use(VueScrollTo);
Vue.use(VueResource);
Vue.use(VueAgile)


Vue.config.productionTip = false
Vue.config.publicPath = './'

new Vue({
  el: '#header-app',
  render: h => h(Header),
});

// new Vue({
//   render: h => h(Social),
// }).$mount('#social-app');

new Vue({
  VueResource,
  render: h => h(Booking),
}).$mount('#booking-app');

new Vue({
  VueResource,
  render: h => h(Slider),
}).$mount('#slider-app');

